<div class="mastercontent">
    <router-outlet></router-outlet>
</div>